import { render } from "./PersonalTraining.vue?vue&type=template&id=457a4b09&ts=true"
import script from "./PersonalTraining.ts?vue&type=script&lang=ts&external"
export * from "./PersonalTraining.ts?vue&type=script&lang=ts&external"

import "./PersonalTraining.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__